import { Subject, Subscription } from 'rxjs';

/**
 *
 * @param source The name of the component or service that is calling this function
 * @param subscription The subscription to be unsubscribed
 * @param destroyAllSubject A subject that will be "nexted" and "completed" to trigger any other cleanup.  For example:
 * ```typescript
 * someOuterObservable.pipe(switchMap(() => someOtherLongRunningObservable.pipe(takeUntil(this.destroyAll$)))
 * ```
 */
export const onDestroyCleanup = (
  source: string,
  subscription: Subscription,
  destroyAllSubject?: Subject<void>,
) => {
  subscription.unsubscribe();
  if (destroyAllSubject) {
    destroyAllSubject.next();
    destroyAllSubject.complete();
  }
  console.debug(`onDestroyCleanup for ${source}`);
};
